var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33594 14.4166H8.66927",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 13.25H9.25",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95275 12.0834V12.6834C5.81559 12.6834 5.68258 12.6364 5.57586 12.5502L5.95275 12.0834ZM9.04725 12.0834L9.42414 12.5502C9.31742 12.6364 9.18441 12.6834 9.04725 12.6834V12.0834ZM7.25 5.02315C7.58137 5.02315 7.85 5.29178 7.85 5.62315C7.85 5.95453 7.58137 6.22316 7.25 6.22316V5.02315ZM6.6 6.89526C6.6 7.22663 6.33137 7.49525 6 7.49525C5.66863 7.49525 5.4 7.22663 5.4 6.89526H6.6ZM4.6 6.89526C4.6 8.48508 4.69455 10.2966 6.32963 11.6165L5.57586 12.5502C3.46381 10.8453 3.4 8.48616 3.4 6.89526H4.6ZM8.67037 11.6165C10.3054 10.2966 10.4 8.48508 10.4 6.89526H11.6C11.6 8.48616 11.5362 10.8453 9.42414 12.5502L8.67037 11.6165ZM10.4 6.89526C10.4 5.02366 8.92489 3.93337 7.5 3.93337V2.73337C9.49339 2.73337 11.6 4.27045 11.6 6.89526H10.4ZM7.5 3.93337C6.07511 3.93337 4.6 5.02366 4.6 6.89526H3.4C3.4 4.27045 5.50661 2.73337 7.5 2.73337V3.93337ZM7.25 6.22316C6.90088 6.22316 6.6 6.51411 6.6 6.89526H5.4C5.4 5.87128 6.2184 5.02315 7.25 5.02315V6.22316ZM5.95275 11.4834L9.04725 11.4834V12.6834L5.95275 12.6834V11.4834Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1V1.875",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08594 7.41663H2.2526",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.41663H13.9167",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.75L2.92029 3.31244",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 11.6665L2.92029 11.1041",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4766 2.75L11.8063 3.31244",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 11.6665L12.3922 11.1041",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.3b00d83818eed4b84826374ae226b3f7.svg";
export { ForwardRef as ReactComponent };